import React from 'react';

import {
  FiltersWrapper,
  MoreParams,
} from '@/modules/CarsStock/components/common.styles';
import AllParamsButton from '@/modules/CarsStock/components/Desktop/components/AllParamsButton';
import { useTypedSelector } from '@/store/store';
import { getShowMoreParams } from '@/store/reducers/cars-stock';

import GearboxFilter from './components/GearboxFilter';
import BodyFilter from './components/BodyFilter/BodyFilter';
import PriceFilter from './components/PriceFilter';
import WheelFilter from './components/WheelFilter';
import YearFilter from './components/YearFilter';
import MileageFilter from './components/MileageFilter';
import ColorFilter from './components/ColorFilter';
import EngineCapacityFilter from './components/EngineCapacityFilter';
import VatFilter from './components/VatFilter';
import LocationFilter from './components/LocationFilter';
import SpecialFilter from './components/SpecialFilter';
import BatteryTypeFilter from './components/BatteryTypeFilter';
import PowerReserveFilter from './components/PowerReserveFilter';
import ElectricEnginesFilter from './components/ElectricEnginesFilter';
import GradeFilter from './components/GradeFilter';

export function ParamsFilterAmp() {
  const isShowMoreParams = useTypedSelector(getShowMoreParams);

  return (
    <React.Fragment>
      <FiltersWrapper>
        <YearFilter />
        <PriceFilter />
        <VatFilter />
      </FiltersWrapper>

      <AllParamsButton />

      <MoreParams isVisible={isShowMoreParams}>
        <FiltersWrapper>
          <GearboxFilter />
          <BodyFilter />
          <EngineCapacityFilter />
          <WheelFilter />
          <MileageFilter />
          <ColorFilter />
          <LocationFilter />
          <BatteryTypeFilter />
          <PowerReserveFilter />
          <ElectricEnginesFilter />
          <GradeFilter />
        </FiltersWrapper>
      </MoreParams>

      <SpecialFilter />
    </React.Fragment>
  );
}
